/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */
import { startTransition, StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { RemixBrowser } from '@remix-run/react'
import { sentryInit, snowplowInitClient } from '~/utils'

// Initialise sentry debugging
if (window?.ENV?.SENTRY_DSN) {
  sentryInit(
    window.ENV.SENTRY_DSN,
    window?.ENV?.ENVIRONMENT_NAME,
    window?.ENV?.SENTRY_DEBUG
  )
}

// Initialise snowplow browser tracking
if (window?.ENV?.SNOWPLOW_APPID && window?.ENV?.SNOWPLOW_URL) {
  snowplowInitClient(
    window.ENV.SNOWPLOW_APPID,
    window.ENV.SNOWPLOW_URL,
    window?.ENV?.SNOWPLOW_DEBUG
  )
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  )
})
